<template>
 
 <div class="bg-[#fbfafa]  min-h-screen bg-gradient-to-br text-white  min-h-screen">
    
      <Navbar />
      <div class="flex">
        <div class="w-1/2 p-8">
          <Hero />
          <div class="grid grid-cols-2 gap-4 mt-8">
            <DialogCard
                title="Explore stock prices" 
                description="Get simulated stock prices" 
                :websocket_url= this.stock_websocket
                :actions="[
                  { 
                    title: 'Connection details', 
                    tabs: [
                      { title: 'Connection Details', content: 'Bootstrap server: source.gateway.apim.event-mock-kafka.gravitee.xyz:9092<br>Protocol: SSL' },
                      { title: 'Node.js', content: substituteKafkaValues(this.nodeCode, 'stock') },
                      { title: 'Python', content: substituteKafkaValues(this.pythonCode, 'stock')  },
                      { title: 'Java', content: substituteKafkaValues(this.javaCode, 'stock')  },
                      { title: 'Rust', content: substituteKafkaValues(this.rustCode, 'stock')  },
                      { title: 'COBOL', content: substituteKafkaValues(this.cobolCode, 'stock')  }
                    ]
                  },
                  { 
                    title: 'See real-time sample data', 
                    tabs: [
                      { title: 'Overview', content: '' },
                     
                    ]
                  }
                ]" 
              />
              
           
           
            <DialogCard
                title="Explore Pizza Orders" 
                description="Get simulated pizza orders" 
                :websocket_url= this.pizza_websocket
                :actions="[
                  { 
                    title: 'Connection details', 
                    tabs: [
                      { title: 'Connection Details', content: 'Bootstrap server: source.gateway.apim.event-mock-kafka.gravitee.xyz:9092<br>Protocol: SSL' },
                      { title: 'Node.js', content: substituteKafkaValues(this.nodeCode, 'pizza') },
                      { title: 'Python', content: substituteKafkaValues(this.pythonCode, 'pizza')  },
                      { title: 'Java', content: substituteKafkaValues(this.javaCode, 'pizza')  },
                      { title: 'Rust', content: substituteKafkaValues(this.rustCode, 'pizza')  },
                      { title: 'COBOL', content: substituteKafkaValues(this.cobolCode, 'pizza')  }
                    ]
                  },
                  { 
                    title: 'See real-time sample data', 
                    tabs: [
                      { title: 'Overview', content: '' },
                     
                    ]
                  }
                ]" 
              />
              <DialogCard
                title="Explore simulated inventory updates" 
                description="Generates a live inventory feed" 
                :websocket_url= this.inventory_websocket
                :actions="[
                  { 
                    title: 'Connection details', 
                    tabs: [
                      { title: 'Connection Details', content: 'Bootstrap server: source.gateway.apim.event-mock-kafka.gravitee.xyz:9092<br>Protocol: SSL' },
                      { title: 'Node.js', content: substituteKafkaValues(this.nodeCode, 'inventory') },
                      { title: 'Python', content: substituteKafkaValues(this.pythonCode, 'inventory')  },
                      { title: 'Java', content: substituteKafkaValues(this.javaCode, 'inventory')  },
                      { title: 'Rust', content: substituteKafkaValues(this.rustCode, 'inventory')  },
                      { title: 'COBOL', content: substituteKafkaValues(this.cobolCode, 'inventory')  }
                    ]
                  },
                  { 
                    title: 'See real-time sample data', 
                    tabs: [
                    { title: 'Overview', content: '' },
                    ]
                  }
                ]" 
              />
              <Card title="Coming Soon: Create custom topic" description="Create your own hosted Kafka topic for quick and easy testing" />
          </div>
        </div>
        <div class="w-1/2 flex items-center justify-center p-8">
          <RealtimeFeed
                title="Connect to Real-Time Data Instantly" 
                description="Use the following credentials to access real-time data through your own application.." 
                :websocket_url= this.inventory_websocket
                :actions="[
                  { 
                    title: 'Connection details', 
                    tabs: [
                      { title: 'Connection Details', content: 'Bootstrap server: source.gateway.apim.event-mock-kafka.gravitee.xyz:9092<br>Protocol: SSL' },
                      { title: 'Node.js', content: substituteKafkaValues(this.nodeCode, 'inventory') },
                      { title: 'Python', content: substituteKafkaValues(this.pythonCode, 'inventory')  },
                      { title: 'Java', content: substituteKafkaValues(this.javaCode, 'inventory')  },
                      { title: 'Rust', content: substituteKafkaValues(this.rustCode, 'inventory')  },
                      { title: 'COBOL', content: substituteKafkaValues(this.cobolCode, 'inventory')  }
                    ]
                  },
                  { 
                    title: 'See real-time sample data', 
                    tabs: [
                    { title: 'Overview', content: '' },
                    ]
                  }
                ]" 
              />
        </div>
      </div>
      <div class="text-center">
  <span class="text-[#403b38] text-sm font-normal font-['Outfit'] leading-none">Event Mock is powered by </span>
  <a href="https://gravitee.io?utm_source=eventmock&utm_medium=web&utm_campaign=sponsorship" target="_blank" rel="noopener noreferrer" class="text-[#403b38] text-sm font-normal font-['Outfit'] underline leading-none">
    gravitee.io
  </a>
  <span class="text-[#403b38] text-sm font-normal font-['Outfit'] leading-none">. All rights reserved.</span>
</div>
    </div>
 

  </template>
  
  <script>
  import hljs from 'highlight.js/lib/core';
  import 'highlight.js/styles/github.css'; // Choose a style
  import Navbar from "@/components/Navbar.vue";
  import Hero from "@/components/HeroSection.vue";
  import Card from "@/components/BaseCard.vue";
  //import Illustration from "@/components/BaseIllustration.vue";
  import RealtimeFeed from "@/components/RealtimeFeed.vue";
  import DialogCard from "@/components/DialogCard.vue";
  import config from '@/config';

import javascript from 'highlight.js/lib/languages/javascript';
hljs.registerLanguage('javascript', javascript);
import python from 'highlight.js/lib/languages/python';
hljs.registerLanguage('python', python);

export default {
  name: 'HomeView',
  components: {
    Navbar,
    Hero,
    Card,
   // Illustration,
    RealtimeFeed,
    DialogCard
    
  },
  methods: {
    replaceCodeValues(sourceText, variableToReplace, variableText) {
      const regex = new RegExp(variableToReplace, 'g');
      return sourceText.replace(regex, variableText);
    },
    substituteKafkaValues(sourceText, dataset) {
      const bootstrapServersKey = `${dataset}_bootstrap_servers`;
      const topicKey = `${dataset}_topic`;
      const replacedText = this.replaceCodeValues(sourceText, '<your-bootstrap-servers>', config[bootstrapServersKey]);
      const finalText = this.replaceCodeValues(replacedText, '<your-topic>', config[topicKey]);
      return hljs.highlight(finalText, { language: 'javascript' }).value;
    }
  },
  data() {
    return {
      nodeCode: config.default_node_code,
      pythonCode: config.default_python_code,
      javaCode: config.default_java_code,
      rustCode: config.default_rust_code,
      cobolCode: config.default_cobol_code,
      nodeCodeText: '',
      pythonCodeText: '',
      stock_websocket: config.stock_websocket,
      pizza_websocket: config.pizza_websocket,
      inventory_websocket: config.inventory_websocket
    }
  },
  computed: {
  highlightedNodeCode() {
    const finalText = this.substituteKafkaValues(this.nodeCode);
    return hljs.highlight(finalText, { language: 'javascript' }).value;
  },
  highlightedPythonCode() {
    return hljs.highlight(this.pythonCode, { language: 'python' }).value;
  }
}
};
</script>
  